export { WaffoPancakeProvider } from "./provider.js";
export { CheckoutButton } from "./checkout-button.js";
export { useCheckout } from "./use-checkout.js";
export { useCustomer, useBuyer } from "./use-customer.js";
export {
  useCustomerOrders,
  useCustomerPayments,
  useCustomerRefundTickets,
  useBuyerOrders,
  useBuyerPayments,
  useBuyerRefundTickets,
} from "./use-customer-data.js";
export { useMerchantOrders, useMerchantSales, useMerchantSubscriptions } from "./use-merchant-data.js";
export { Webhook } from "./webhook.js";

// Re-export types commonly used in client components
export { WaffoPancakeError, ChangeTiming, TaxCategory, WebhookEventType } from "@waffo/pancake-ts";

export type {
  PriceInfo,
  PriceSnapshot,
  BillingDetail,
  RequestedAmount,
  RefundTicketVersionData,
  WebhookEvent,
  WebhookEventData,
  CashierLanguage,
  PaymentMethod,
  RequestOptions,
} from "@waffo/pancake-ts";

// Local types
export type {
  CheckoutMode,
  CheckoutBaseOptions,
  LinkCheckoutProps,
  AnonymousCheckoutProps,
  AuthenticatedCheckoutProps,
  CheckoutProps,
  UseCheckoutReturn,
} from "./types.js";

export type { CustomerConfig, BuyerConfig, WaffoPancakeProviderProps } from "./provider.js";

export type {
  CheckoutButtonProps,
  LinkCheckoutButtonProps,
  AnonymousCheckoutButtonProps,
  AuthenticatedCheckoutButtonProps,
} from "./checkout-button.js";

export type { CustomerActionState, UseCustomerReturn, BuyerActionState, UseBuyerReturn } from "./use-customer.js";

export type { QueryState } from "./use-query.js";

export type {
  CustomerOnetimeOrder,
  CustomerSubscriptionOrder,
  CustomerPayment,
  CustomerRefundTicket,
  BuyerOnetimeOrder,
  BuyerSubscriptionOrder,
  BuyerPayment,
  BuyerRefundTicket,
} from "./use-customer-data.js";

export type {
  MerchantOrder,
  MerchantSubscription,
  SalesOverview,
  SubscriptionOverview,
  MerchantOrdersOptions,
} from "./use-merchant-data.js";

export type { WebhookConfig } from "./webhook.js";

// Server action types (for typing the action prop)
export type {
  CheckoutAction,
  CheckoutActionParams,
  CheckoutActionResult,
  CustomerTokenAction,
  CustomerSessionAction,
  BuyerTokenAction,
  BuyerSessionAction,
  MerchantQueryAction,
} from "./server.js";
